module.exports = {
	"name": "PS4 Chrome Windows",
	"supported": [
		{
			"id": "Wireless Controller (STANDARD GAMEPAD Vendor: 054c Product: 05c4)",
			"os": "Windows NT",
			"browser": "Chrome"
		}
	],
	"axes": {
		"left stick x": {
			"index": 0
		},
		"left stick y": {
			"index": 1
		},
		"right stick y": {
			"index": 3
		},
		"right trigger": {
			"index": 5
		},
		"dpad x": {
			"index": 6
		},
		"dpad y": {
			"index": 7
		},
		"right stick x": {
			"index": 2
		}
	},
	"buttons": {
		"a": {
			"index": 0
		},
		"b": {
			"index": 1
		},
		"x": {
			"index": 2
		},
		"y": {
			"index": 3
		},
		"left shoulder": {
			"index": 4
		},
		"right shoulder": {
			"index": 5
		},
		"left stick": {
			"index": 10
		},
		"right stick": {
			"index": 11
		},
		"dpad left": {
			"index": 14
		},
		"dpad right": {
			"index": 15
		},
		"dpad up": {
			"index": 12
		},
		"dpad down": {
			"index": 13
		},
		"left trigger": {
			"index": 6
		},
		"right trigger": {
			"index": 7
		},
		"right stick right": {
			"axis": 2,
			"direction": 1
		},
		"right stick up": {
			"axis": 3,
			"direction": -1
		},
		"right stick left": {
			"axis": 2,
			"direction": -1
		},
		"right stick down": {
			"axis": 3,
			"direction": 1
		},
		"left stick left": {
			"axis": 0,
			"direction": -1
		},
		"left stick up": {
			"axis": 1,
			"direction": -1
		},
		"left stick right": {
			"axis": 0,
			"direction": 1
		},
		"left stick down": {
			"axis": 1,
			"direction": 1
		},
		"back": {
			"index": 8
		},
		"home": {
			"index": 17
		},
		"start": {
			"index": 9
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/html5-gamepad/mappings/ps4-chrome-windows.json
// module id = 211
// module chunks = 0